export default {
  students: [],
  student: {},

  //MÓDULO DE AGENDAS
  studentListSchedules: []
}
